
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-workshop-based-mains-prelims-test-series",
      function () {
        return require("private-next-pages/tnpsc-workshop-based-mains-prelims-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-workshop-based-mains-prelims-test-series"])
      });
    }
  